import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { createFulfillmentOrderApi } from './createFulfillmentOrder.api'
import createFulfillmentOrderInitialState from './createFulfillmentOrder.initialState'
import {
  CreateFulfillmentOrderErrorResponse,
  CreateFulfillmentOrderRequestPayload
} from './createFulfillmentOrder.types'

export const createFulfillmentOrder = createAsyncThunk(
  urls.fulfillmentOrders.createFulfillmentOrder,
  async (payload: CreateFulfillmentOrderRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await createFulfillmentOrderApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const createFulfillmentOrderSlice = createSlice({
  name: urls.fulfillmentOrders.createFulfillmentOrder,
  initialState: createFulfillmentOrderInitialState,
  reducers: {
    resetCreateFulfillmentOrder: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFulfillmentOrder.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(createFulfillmentOrder.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(createFulfillmentOrder.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as CreateFulfillmentOrderErrorResponse
        state.success = null
      })
  }
})

export const { actions: createFulfillmentOrderActions, reducer: createFulfillmentOrderReducer } =
  createFulfillmentOrderSlice

export const { resetCreateFulfillmentOrder } = createFulfillmentOrderActions

export default createFulfillmentOrderSlice.reducer
